
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M16.12 11.5C16.51 10.83 16.03 10 15.26 10H13.39L15.67 12.28L16.12 11.5ZM16.28 3.45C16.61 2.78 16.13 2 15.38 2H7.99998C7.44998 2 6.99998 2.45 6.99998 3V3.61L13.13 9.74L16.28 3.45ZM18.44 17.88L4.11998 3.56C3.72998 3.17 3.09998 3.17 2.70998 3.56C2.31998 3.95 2.31998 4.58 2.70998 4.97L6.99998 9.27V12C6.99998 12.55 7.44998 13 7.99998 13H9.99998V20.15C9.99998 20.66 10.67 20.84 10.93 20.4L13.58 15.85L17.02 19.29C17.41 19.68 18.04 19.68 18.43 19.29C18.83 18.9 18.83 18.27 18.44 17.88Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-flash-off`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconFlashOff

    ```js
    <b-new-b-icon-flash-off />
    ```
</docs>


